/**
 * @generated SignedSource<<d04b69fa580799bc0c89db111f16e429>>
 * @relayHash 0e776853fefa159d816e2c024912cbe1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2cdf282128aedbae37919f8086e582b2f8228a0c742a9c35de5a5b789174c666

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraIssueTypeInput = {
  id?: string | null | undefined;
  issueTypeId: string;
};
export type JiraArchivedOnDateRange = {
  from?: AGG$Date | null | undefined;
  to?: AGG$Date | null | undefined;
};
export type main_getArchivedIssuesForProjectQuery$variables = {
  archivalDateRange?: JiraArchivedOnDateRange | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  last?: number | null | undefined;
  projectKey: string;
  searchBy?: string | null | undefined;
  selectedArchivedBy?: ReadonlyArray<string> | null | undefined;
  selectedIssueTypes?: ReadonlyArray<JiraIssueTypeInput> | null | undefined;
  selectedReporters?: ReadonlyArray<string> | null | undefined;
};
export type main_getArchivedIssuesForProjectQuery$data = {
  readonly jira: {
    readonly getArchivedIssuesForProject: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly archivedBy: {
            readonly id: string;
            readonly name: string;
            readonly picture: AGG$URL;
          } | null | undefined;
          readonly archivedOn: AGG$DateTime | null | undefined;
          readonly fieldsById: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly user?: {
                  readonly id: string;
                  readonly name: string;
                  readonly picture: AGG$URL;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly issueId: string;
          readonly issueTypeField: {
            readonly issueType: {
              readonly avatar: {
                readonly medium: string | null | undefined;
              } | null | undefined;
              readonly hierarchy: {
                readonly level: number | null | undefined;
              } | null | undefined;
              readonly name: string;
            } | null | undefined;
          } | null | undefined;
          readonly key: string;
          readonly summaryField: {
            readonly text: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly totalCount: number | null | undefined;
    } | null | undefined;
    readonly unarchiveIssuePermission: boolean | null | undefined;
  } | null | undefined;
};
export type main_getArchivedIssuesForProjectQuery = {
  response: main_getArchivedIssuesForProjectQuery$data;
  variables: main_getArchivedIssuesForProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "archivalDateRange"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedArchivedBy"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedIssueTypes"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedReporters"
},
v9 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v10 = [
  (v9/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "byArchivalDateRange",
        "variableName": "archivalDateRange"
      },
      {
        "kind": "Variable",
        "name": "byArchivedBy",
        "variableName": "selectedArchivedBy"
      },
      {
        "kind": "Variable",
        "name": "byIssueType",
        "variableName": "selectedIssueTypes"
      },
      {
        "kind": "Variable",
        "name": "byProject",
        "variableName": "projectKey"
      },
      {
        "kind": "Variable",
        "name": "byReporter",
        "variableName": "selectedReporters"
      }
    ],
    "kind": "ObjectValue",
    "name": "filterBy"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "searchBy",
    "variableName": "searchBy"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v12 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v13 = {
  "kind": "ScalarField",
  "name": "key"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "medium"
    }
  ]
},
v16 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "ScalarField",
  "name": "picture"
},
v19 = [
  {
    "kind": "Literal",
    "name": "ids",
    "value": [
      "reporter"
    ]
  }
],
v20 = {
  "kind": "ScalarField",
  "name": "archivedOn"
},
v21 = {
  "kind": "ScalarField",
  "name": "text"
},
v22 = {
  "alias": "unarchiveIssuePermission",
  "args": [
    (v9/*: any*/),
    {
      "kind": "Literal",
      "name": "permission",
      "value": "UNARCHIVE_ISSUES"
    },
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "hasProjectPermission"
},
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_getArchivedIssuesForProjectQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "getArchivedIssuesForProject",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "archivedBy",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "args": (v19/*: any*/),
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v14/*: any*/),
                                          (v18/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraSingleSelectUserPickerField"
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldsById(ids:[\"reporter\"])"
                      },
                      (v20/*: any*/),
                      {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v22/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_getArchivedIssuesForProjectQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "getArchivedIssuesForProject",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "archivedBy",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "args": (v19/*: any*/),
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v23/*: any*/),
                                          (v17/*: any*/),
                                          (v14/*: any*/),
                                          (v18/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraSingleSelectUserPickerField"
                                  },
                                  (v17/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldsById(ids:[\"reporter\"])"
                      },
                      (v20/*: any*/),
                      {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v17/*: any*/)
                        ]
                      },
                      (v17/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v22/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "2cdf282128aedbae37919f8086e582b2f8228a0c742a9c35de5a5b789174c666",
    "metadata": {},
    "name": "main_getArchivedIssuesForProjectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "057ef912015668de758a06351fea8bcf";

export default node;
